function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: "auto",
    direction: "vertical",
    navigation: false,
  };
}

const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-list") &&
    document.querySelectorAll(".js-media-list").length > 0
  ) {
    document.querySelectorAll(".js-media-list").forEach((elem, index) => {
      if (elem.swiper) return; // already initialized — skip to avoid duplicate instances
      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 2,
        autoHeight: true,
        navigation: false,
        simulateTouch: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
        thumbs: {
          swiper: document.querySelectorAll(".js-media-sublist")[index]?.swiper,
        },
        on: {
          slideChangeTransitionStart: function () {
            document
              .querySelectorAll(".js-media-sublist")
              [index].swiper.slideTo(
                document.querySelectorAll(".js-media-list")[index].swiper
                  .activeIndex
              );
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 800);
      }
    });
  }
};

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-sublist") &&
    document.querySelectorAll(".js-media-sublist").length > 0
  ) {
    document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
      if (elem.swiper) return; // already initialized — skip to avoid duplicate instances
      const thumbnailCount = Number(elem.dataset?.thumbnailCount);
      const parent = elem.closest(".product__media-sublist-outer");
      const nextBtn = parent.querySelector(".product__button-next");
      const prevBtn = parent.querySelector(".product__button-prev");

      const isDesktopHorizontal = elem.classList.contains(
        "horizontal-thumbnails"
      );

      let subSlider = new Swiper(elem, {
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerView: 3,
        spaceBetween: 8,
        direction: "horizontal",
        navigation: {
          nextEl: nextBtn ? nextBtn : null,
          prevEl: prevBtn ? prevBtn : null,
        },
        simulateTouch: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
        freeMode: false,
        on: {
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        transitionStart: function () {
          document
            .querySelector(".js-media-list")
            .swiper.slideTo(
              document.querySelectorAll(".js-media-sublist")[index].swiper
                .activeIndex
            );
        },
        breakpoints: {
          1200: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            direction: isDesktopHorizontal ? "horizontal" : "vertical",
            slidesPerView: thumbnailCount ? thumbnailCount : 3,
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    var eventList = ["paste", "input"];

    for (event of eventList) {
      this.input.addEventListener(event, (e) => {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ""
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }
        this.updateButtonStates();
      });
    }

    this.input.addEventListener("focusout", (e) => {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
      }
      this.updateButtonStates();
    });

    this.updateButtonStates();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const isPlus = event.target.name === "plus";
    const min = parseInt(this.input.min) || 0;
    const max = this.input.max !== "" ? parseInt(this.input.max) : null;
    const val = parseInt(this.input.value) || 0;

    if (isPlus && max !== null && val >= max) {
      this.input.setCustomValidity(
        window.quickOrderListStrings
          ? window.quickOrderListStrings.max_error.replace("[max]", max)
          : `Maximum quantity is ${max}`
      );
      this.input.reportValidity();
      return;
    }

    if (!isPlus && val <= min) {
      if (min > 0) {
        this.input.setCustomValidity(
          window.quickOrderListStrings
            ? window.quickOrderListStrings.min_error.replace("[min]", min)
            : `Minimum quantity is ${min}`
        );
        this.input.reportValidity();
      }
      return;
    }

    this.input.setCustomValidity("");
    isPlus ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.updateButtonStates();
  }

  updateButtonStates() {
    const min = parseInt(this.input.min) || 0;
    const max = this.input.max !== "" ? parseInt(this.input.max) : null;
    const val = parseInt(this.input.value) || 0;

    const minusBtn = this.querySelector('[name="minus"]');
    const plusBtn = this.querySelector('[name="plus"]');

    if (minusBtn) {
      const atMin = val <= min;
      atMin
        ? minusBtn.setAttribute("aria-disabled", "true")
        : minusBtn.removeAttribute("aria-disabled");
      minusBtn.classList.toggle("quantity__button--disabled", atMin);
    }

    if (plusBtn) {
      const atMax = max !== null && val >= max;
      atMax
        ? plusBtn.setAttribute("aria-disabled", "true")
        : plusBtn.removeAttribute("aria-disabled");
      plusBtn.classList.toggle("quantity__button--disabled", atMax);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (
      navigator.platform === "iPhone" ||
      /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      const updateViewportHeight = () => {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      };
      updateViewportHeight();
      window.addEventListener("resize", updateViewportHeight);
    }

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".toggle-scheme-button") === button) return;
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    this.header =
      this.header || document.querySelector(".shopify-section-header");
    const headerTop = document.querySelector(
      ".shopify-section-header .header__top"
    );
    const headerSearch = document.querySelector(
      ".shopify-section-header .search__content"
    );
    const headerBottom = document.querySelector(
      ".shopify-section-header .header__bottom"
    );
    const hasOverlay = this.header.classList.contains("has-overlay");

    if (hasOverlay) {
      this.header =
        this.header || document.querySelector(".shopify-section-header");
      if (
        this.header.classList.contains("color-background-3") &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.remove("color-background-3");
        headerTop.classList.remove("color-background-3");
        headerSearch.classList.remove("color-background-3");
        headerBottom?.classList?.remove("color-background-3");
      }

      if (hasOverlay) {
        this.header.classList.remove("color-background-3");
        headerTop.classList.remove("color-background-3");
        headerSearch.classList.remove("color-background-3");
        headerBottom?.classList?.remove("color-background-3");
      }
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    const headerTop = document.querySelector(
      ".shopify-section-header .header__top"
    );
    const headerSearch = document.querySelector(
      ".shopify-section-header .search__content"
    );
    const headerBottom = document.querySelector(
      ".shopify-section-header .header__bottom"
    );
    const hasOverlay = this.header.classList.contains("has-overlay");

    if (hasOverlay) {
      if (
        this.header.classList.contains("color-background-3") &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.remove("color-background-3");
        headerTop.classList.remove("color-background-3");
        headerSearch.classList.remove("color-background-3");
        headerBottom?.classList?.remove("color-background-3");
      }

      if (hasOverlay) {
        this.header.classList.remove("color-background-3");
        headerTop.classList.remove("color-background-3");
        headerSearch.classList.remove("color-background-3");
        headerBottom?.classList?.remove("color-background-3");
      }
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);

      this.header =
        this.header || document.querySelector(".shopify-section-header");
      const hasOverlay = this.header.classList.contains("has-overlay");
      const headerTop = document.querySelector(
        ".shopify-section-header .header__top"
      );
      const headerSearch = document.querySelector(
        ".shopify-section-header .search__content"
      );
      const headerBottom = document.querySelector(
        ".shopify-section-header .header__bottom"
      );

      if (hasOverlay && !this.header.classList.contains("animate")) {
        this.header.classList.add("color-background-1", "color-background-3");
      }
      if (
        hasOverlay &&
        this.header.classList.contains("color-background-1") &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.add("color-background-3");
        headerTop.classList.add("color-background-3");
        headerSearch.classList.add("color-background-3");
        headerBottom?.classList?.add("color-background-3");
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

(function () {
  const initHeaderOverlay = () => {
    const header = document.querySelector(".shopify-section-header");
    const hasOverlay = header?.classList.contains("has-overlay");

    if (!hasOverlay) return;

    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector(
        ".section--has-overlay"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );

      const headerTop = document.querySelector(
        ".shopify-section-header .header__top"
      );
      const headerSearch = document.querySelector(
        ".shopify-section-header .search__content"
      );
      const headerBottom = document.querySelector(
        ".shopify-section-header .header__bottom"
      );

      if (sectionFirstChild && header) {
        if (hasOverlay) {
          if (headerGroupSections[headerGroupSections.length - 1] === header) {
            sections[0].classList.remove("not-margin");
            header.classList.add("color-background-1", "color-background-3");
            headerTop.classList.add("color-background-1", "color-background-3");
            headerSearch.classList.add(
              "color-background-1",
              "color-background-3"
            );
            headerBottom?.classList?.add(
              "color-background-1",
              "color-background-3"
            );
          } else {
            sections[0].classList.add("not-margin");
            header.classList.remove("color-background-1", "color-background-3");
            headerTop.classList.remove(
              "color-background-1",
              "color-background-3"
            );
            headerSearch.classList.remove(
              "color-background-1",
              "color-background-3"
            );
            headerBottom?.classList?.remove(
              "color-background-1",
              "color-background-3"
            );
          }
        } else {
          sections[0].classList.remove("not-margin");
          header.classList.remove("color-background-1", "color-background-3");
          headerTop.classList.remove(
            "color-background-1",
            "color-background-3"
          );
          headerSearch.classList.remove(
            "color-background-1",
            "color-background-3"
          );
          headerBottom?.classList?.remove(
            "color-background-1",
            "color-background-3"
          );
        }
      }
    }
  };

  initHeaderOverlay();

  document.addEventListener("shopify:section:load", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:unload", function () {
    initHeaderOverlay();
  });

  document.addEventListener("shopify:section:reorder", function () {
    initHeaderOverlay();
  });
})();

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      /*this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      ).focus();*/

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute("data-autoplay")) {
              let playPromise = entry.target.play();
              if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
              }
              //entry.target.play()
            }
          } else {
            entry.target.pause();
          }
        });
      });

      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      //if (focus) deferredElement.focus();

      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        // force autoplay for safari

        if (this.classList.contains("video-section__media")) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
          }

          videoObserver.observe(deferredElement);
        } else {
          deferredElement.play();
        }
      }

      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.is_preorder = false;
    this.is_group_buy = false;
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    // For <select> elements the change event fires on the select itself, not
    // the chosen <option>. Read productUrl from the selected option instead.
    const combinedProductURL =
      event.target.tagName === "SELECT"
        ? event.target.options[event.target.selectedIndex]?.dataset?.productUrl
        : event.target.dataset?.productUrl;

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;

    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        combinedProductURL,
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
      }
      if (combinedProductURL) {
        this.isCombinedListingsNeedUpdate = true;
        this.currentCombinedProductURL = combinedProductURL;
      }
    }

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
      this.updateInventory();
      this.updateRestockInfo();
      this.updateVariantsLabels();
      this.updateConditionDescription();
      //this.updateAvaliabilityNotificationInfo();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (
        !this.closest("floated-form") ||
        (this.currentVariant?.featured_media &&
          this.dataset?.variantMediaDisplay === "show_all")
      ) {
        // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
        //const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        combinedProductURL,
        currentVariantId: this.currentVariant.id,
        combinedProductURL: combinedProductURL,
      });
      this.renderProductInfo(requestUrl);
    }

    if (this.currentVariant) {
      // dispatch variant:change
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
            previousVariant: this.previousVariant || null,
            formElement: document.querySelector(`#${this.getAttribute("id")}`),
            sectionId: this.dataset.section,
          },
        })
      );
      // dispatch variant:change

      // Save the previous version
      this.previousVariant = this.currentVariant;
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];
    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      // radio-style pickers (button / image / color swatch)
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      if (checkedInput?.dataset?.optionValueId) {
        return checkedInput.dataset.optionValueId;
      }
      // dropdown-style pickers — read optionValueId from the selected <option>
      const selectEl = control.querySelector("select");
      if (selectEl) {
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        return selectedOption?.dataset?.optionValueId || null;
      }
      return null;
    });
  }

  createRequestUrl({
    combinedProductURL = "",
    currentVariantId = "",
    selectedValuesIds = [],
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  normalizeQuantityValue({ desiredQuantity, min, max, step, fallback }) {
    const safeMin = Number.isFinite(min) ? min : 1;
    const safeStep = Number.isFinite(step) && step > 0 ? step : 1;
    const hasMax = Number.isFinite(max);
    const safeMax = hasMax ? max : null;
    let quantity = Number.isFinite(desiredQuantity) ? desiredQuantity : fallback;

    if (!Number.isFinite(quantity)) {
      quantity = safeMin;
    }

    if (quantity < safeMin) {
      quantity = safeMin;
    }

    if (hasMax && quantity > safeMax) {
      quantity = safeMax;
    }

    // Keep quantity aligned to the active variant's min/step progression.
    if ((quantity - safeMin) % safeStep !== 0) {
      quantity =
        safeMin + Math.floor((quantity - safeMin) / safeStep) * safeStep;
    }

    if (quantity < safeMin) {
      quantity = safeMin;
    }

    if (hasMax && quantity > safeMax) {
      quantity =
        safeMin + Math.floor((safeMax - safeMin) / safeStep) * safeStep;
      if (quantity < safeMin) {
        quantity = safeMin;
      }
    }

    return quantity;
  }

  setCurrentVariantAfterFetch(html) {
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const currentBlockId = this.dataset.block;

    // variant-radios uses "variant-radios-{section}-{block}";
    // variant-selects uses "variant-selects-{section}" (no block suffix).
    const variantPickerSource =
      html.getElementById(
        `variant-radios-${sourceSectionId}-${currentBlockId}`
      ) || html.getElementById(`variant-selects-${sourceSectionId}`);
    const variantPickerDestionation =
      document.getElementById(
        `variant-radios-${this.dataset.section}-${currentBlockId}`
      ) || document.getElementById(`variant-selects-${this.dataset.section}`);
    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = variantPickerSource.querySelector(
      "[data-selected-variant]"
    ).innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestionation.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        /*this.options.sort();
        variant.options.sort();*/

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia() {
    if (!this.currentVariant) return;

    // Open-box companion variants carry no image of their own: the gallery renders the
    // New parent's media, so borrow the parent's image for the same config. The map is
    // baked into the companion PDP by sections/main-product.liquid; undefined elsewhere.
    const mediaId =
      this.currentVariant.featured_media?.id ??
      window.COMPANION_VARIANT_MEDIA?.[this.currentVariant.id];
    if (!mediaId) return;

    const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${mediaId}"]`
        );
        if (!newMedia) return;

        if (elem.querySelector(".js-media-list").swiper) {
          elem
            .querySelector(".js-media-list")
            .swiper.slideTo(
              elem
                .querySelector(".js-media-list")
                .swiper.slides.indexOf(newMedia)
            );
        }
      }
    });
  }

  updateURL() {
    if (!this.classList.contains("featured-product-radios")) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      const productUrl = this.currentCombinedProductURL || this.dataset.url;
      window.history.replaceState(
        {},
        "",
        `${productUrl}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const firstChecked = this.querySelector(":checked");
    if (!firstChecked) return;
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => firstChecked.value === variant.options[0]
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const prevChecked = inputWrappers[index - 1].querySelector(":checked");
      if (!prevChecked) return;
      const previousOptionSelected = prevChecked.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[index - 1] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updateConditionDescription() {
    const container = document.getElementById(`ConditionDescription-${this.dataset.section}`);
    if (!container) return;

    const fieldset = Array.from(this.querySelectorAll(".product-form__controls")).find((fieldset) => {
      const label = fieldset.querySelector("legend, label");
      return label && label.textContent.trim().replace(/:$/, "") === "Condition";
    });
    const input = fieldset && (fieldset.querySelector("input:checked") || fieldset.querySelector("select"));
    const condition = input ? input.value : null;

    const dataScript = document.getElementById(`ConditionDescriptionData-${this.dataset.section}`);
    const descriptions = dataScript ? JSON.parse(dataScript.textContent) : {};
    const text = condition ? descriptions[condition] : null;
    const textEl = container.querySelector(".condition-description__text");
    const headingEl = container.querySelector(".condition-description__heading");

    if (text && textEl) {
      textEl.textContent = text;
      if (headingEl) headingEl.textContent = `${condition} Condition`;
      container.hidden = false;
    } else {
      container.hidden = true;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      this.currentVariant.inventory_quantity > 0
    ) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateInventory() {
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const inventory_container = document.getElementById("in_stock_text");
    if (this.currentVariant && inventory_container) {
      if (
        (this.currentVariant.available &&
          this.currentVariant.inventory_quantity >=
            (this.currentVariant.metafields.qty_step &&
            this.currentVariant.metafields.qty_step > 1
              ? 400
              : 20)) ||
        this.currentVariant.inventory_quantity < 1
      ) {
        inventory_container.parentElement.classList.add("hidden");
      } else {
        inventory_container.parentElement.classList.remove("hidden");
        if (inventory)
          document.getElementById("inventory_info").innerHTML =
            this.currentVariant.inventory_quantity > 0
              ? this.currentVariant.inventory_quantity + " in Stock Now"
              : "Out of stock";
      }
    }
  }

  generateEstimatedRestock(confidence, etaInSeconds) {
    let estimatedRestock = "Estimated restock: ";
    const etaDate = new Date(etaInSeconds * 1000);
    const etaDay = etaDate.getDate();
    const maxEtaDate = new Date(etaDate);
    maxEtaDate.setDate(1); // a workaround the edge case where 31/3 + 1 month gives May

    switch (confidence) {
      case "high":
        estimatedRestock += `${etaDate.toLocaleString("default", {
          month: "long",
        })} ${etaDay}, ${etaDate.getFullYear()}`;
        break;
      case "medium":
        let minEta = "";
        let maxEta = "";
        if (etaDay < 10) {
          minEta = "Early ";
          maxEta = "Mid ";
        } else if (etaDay < 20) {
          minEta = "Mid ";
          maxEta = "Late ";
        } else {
          minEta = "Late ";
          maxEta = "Early ";
          maxEtaDate.setMonth(etaDate.getMonth() + 1);
        }

        const currentMonth = etaDate.toLocaleString("default", {
          month: "short",
        });
        const nextMonth = maxEtaDate.toLocaleString("default", {
          month: "short",
        });

        estimatedRestock += `${minEta} ${currentMonth} - ${maxEta} ${nextMonth} ${maxEtaDate.getFullYear()}`;
        break;
      default:
        maxEtaDate.setMonth(etaDate.getMonth() + 1);
        let minEtaDefault = "";
        let maxEtaDefault = "";
        if (etaDay < 10) {
          minEtaDefault = "Early ";
        } else if (etaDay < 20) {
          minEtaDefault = "Mid ";
        } else {
          minEtaDefault = "Late ";
        }

        const currentMonthDefault = etaDate.toLocaleString("default", {
          month: "short",
        });
        const nextMonthDefault = maxEtaDate.toLocaleString("default", {
          month: "short",
        });

        estimatedRestock += `${minEtaDefault} ${currentMonthDefault} - ${minEtaDefault} ${nextMonthDefault} ${maxEtaDate.getFullYear()}`;
        break;
    }

    return estimatedRestock;
  }

  updateRestockInfo() {
    const restock_container = document.getElementById("restock-container");
    const instock_container = document.getElementById("instock-container");
    const group_buy_container = document.getElementById("group-buy-container");
    var addButton = document.querySelector("button.product-form__submit");
    var paymentButton = document.querySelector(
      "[data-shopify='payment-button']"
    );

    if (addButton) addButton.classList.remove("force-disabled-button");

    this.is_preorder = false;
    this.is_group_buy = false;
    if (!this.currentVariant) return;
    if (this.currentVariant.inventory_quantity <= 0) {
      instock_container.classList.add("hidden");
      if (
        this.currentVariant.metafields.eta_stamp &&
        this.currentVariant.inventory_policy == "continue"
      ) {
        this.is_preorder = true;
        if (
          this.currentVariant.metafields.special_status &&
          this.currentVariant.metafields.special_status == "Group Buy"
        ) {
          this.is_group_buy = true;
          group_buy_container.classList.remove("hidden");
          restock_container.classList.add("hidden");

          document.getElementById("gb-restock-info").innerHTML = this
            .currentVariant.metafields.eta_override
            ? this.currentVariant.metafields.eta_override
            : this.generateEstimatedRestock(
                this.currentVariant.metafields.confidence,
                this.currentVariant.metafields.eta_stamp
              );
          if (addButton) {
            addButton.classList.remove("pre-order-button");
            addButton.classList.add("group-buy-button");
            var spanChild = addButton.querySelector("span");
            if (spanChild) {
              spanChild.innerHTML = "Join Group Buy";
            }
          }

          if (paymentButton) {
            paymentButton.style.display = "none";
          }
        } else {
          restock_container.classList.remove("hidden");
          group_buy_container.classList.add("hidden");

          document.getElementById("restock-info").innerHTML =
            this.generateEstimatedRestock(
              this.currentVariant.metafields.confidence,
              this.currentVariant.metafields.eta_stamp
            );
          if (addButton) {
            addButton.classList.remove("group-buy-button");
            addButton.classList.add("pre-order-button");
            var spanChild = addButton.querySelector("span");
            if (spanChild) {
              spanChild.innerHTML = "Pre-order";
            }
          }

          if (paymentButton) {
            paymentButton.style.display = "none";
          }
        }
        // onVariantChange() disables the button before this method runs, and at
        // that point is_preorder still holds the previous variant's value. Now
        // that the pre-order / group-buy flags are set, re-enable it — without
        // this the first option click after page load leaves "Join Group Buy"
        // (or "Pre-order") greyed out and unclickable.
        this.toggleAddButton(false);
      } else {
        if (paymentButton) {
          paymentButton.style.display = "none";
        }
        if (addButton) {
          addButton.classList.remove("pre-order-button");
          addButton.classList.remove("group-buy-button");
        }
        restock_container.classList.add("hidden");
        group_buy_container.classList.add("hidden");
        this.toggleAddButton(true, window.variantStrings.soldOut);
      }
    } else {
      if (this.currentVariant.preorder_variant_exist) {
        instock_container.classList.remove("hidden");
      }
      restock_container.classList.add("hidden");
      group_buy_container.classList.add("hidden");
      if (addButton) addButton.classList.remove("pre-order-button");
      this.toggleAddButton(false);
      if (paymentButton) {
        paymentButton.style.display = "block";
      }
    }
  }

  updateVariantsLabels() {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      const listOfOptions = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      listOfOptions.forEach((input) => {
        var labelElement = document.querySelector(
          'label[for="' + input.id + '"]'
        );
        var variants = this.variantData.filter(
          (variant) =>
            input.value === variant.option1 || input.value === variant.option2
        );
        if (input.checked) labelElement.classList.remove("preorder-border");
        else {
          variants.forEach((variant) => {
            if (
              variant.inventory_quantity <= 0 &&
              variant.metafields.eta_stamp > 0 &&
              variant.inventory_policy == "continue"
            )
              labelElement.classList.add("preorder-border");
          });
        }
      });
    });
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections

        //if (this.currentVariant?.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (
                this.currentVariant.featured_media &&
                this.dataset?.variantMediaDisplay === "show_all"
              ) {
                // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
                this.updateMedia();
              }
              //this.updateAvaliabilityNotificationInfo();
            }
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant?.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const currentBlockId = this.dataset.block;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource =
      html.getElementById(
        `variant-radios-${sourceSectionId}-${currentBlockId}`
      ) || html.getElementById(`variant-selects-${sourceSectionId}`);
    const variantPickerDestination =
      document.getElementById(
        `variant-radios-${currentSectionId}-${currentBlockId}`
      ) || document.getElementById(`variant-selects-${currentSectionId}`);
    if (variantPickerSource && variantPickerDestination) {
      variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
    }
  }

  updateElementsAfterFetch(html) {
    // For combined listing switches initiated from the floated form the section
    // id stored on `this` carries the "floated-" prefix, which means every
    // getElementById / querySelector that looks for the real page element would
    // miss. Strip the prefix so those lookups always target the live DOM.
    const liveSection = this.isCombinedListingsNeedUpdate
      ? this.dataset.section.replace(/^floated-/, "")
      : this.dataset.section;

    // currentSectionId / sourceSectionId are used by the media block below.
    // sourceSectionId: the section id used in the fetched HTML (originalSection
    //   for QV / floated; otherwise the live section).
    // currentSectionId: the section id used to query the live page DOM.
    const currentSectionId = liveSection;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : liveSection;

    // price element
    const destination = document.getElementById(`price-${liveSection}`);
    const source = html.getElementById(
      `price-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : liveSection
      }`
    );
    if (source && destination) destination.innerHTML = source.innerHTML;

    const price = document.getElementById(`price-${liveSection}`);
    if (price) price.classList.remove("visibility-hidden");

    // SKU element
    const skuSource = html.getElementById(
      `Sku-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : liveSection
      }`
    );
    const skuDestination = document.getElementById(`Sku-${liveSection}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // inventory element
    const inventorySource = html.getElementById(
      `Inventory-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : liveSection
      }`
    );
    const inventoryDestination = document.getElementById(
      `Inventory-${liveSection}`
    );

    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
    }

    if (inventoryDestination) {
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource?.innerText === ""
      );
    }

    // color name labels
    const colorNameSources = html.querySelectorAll(
      `[data-color-name-id="ColorName-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : liveSection
      }"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[data-color-name-id="ColorName-${
        this.dataset.originalSection && !this.closest("quick-add-modal")
          ? this.dataset.originalSection
          : liveSection
      }"]`
    );
    const colorNameDestinationsFloat = document.querySelectorAll(
      `[data-color-name-id="ColorName-floated-${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : liveSection
      }"]`
    );
    // For combined listing switches always update both main and floated color
    // name labels; for regular changes keep the original inside/outside logic.
    if (this.isCombinedListingsNeedUpdate) {
      if (colorNameSources?.length > 0) {
        colorNameDestinations.forEach((colorNameDestination, index) => {
          if (colorNameSources[index])
            colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
        });
        colorNameDestinationsFloat.forEach((colorNameDestination, index) => {
          if (colorNameSources[index])
            colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
        });
      }
    } else {
      const isInsideFloated = Boolean(this.closest("floated-form"));
      if (
        !isInsideFloated &&
        colorNameSources?.length === colorNameDestinations?.length
      ) {
        colorNameDestinations.forEach((colorNameDestination, index) => {
          colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
        });
      }
      if (
        isInsideFloated &&
        colorNameSources?.length === colorNameDestinationsFloat?.length
      ) {
        colorNameDestinationsFloat.forEach((colorNameDestination, index) => {
          colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
        });
      }
    }

    this.toggleAddButton(
      !this.currentVariant?.available ||
        (this.currentVariant?.inventory_quantity <= 0 &&
          (!this.currentVariant?.metafields?.eta_stamp ||
            this.currentVariant?.inventory_policy != "continue")),
      window.variantStrings.soldOut
    );

    const variant_sku = document.getElementById(`variant_sku`);
    if (variant_sku && this.currentVariant)
      variant_sku.innerText = "SKU: " + this.currentVariant.sku;

    // B2B quantity pricing sync
    const sourceButtonsWrapper = html.querySelector(
      `[data-id="ProductButtons-${sourceSectionId}"]`
    );
    const destButtonsWrappers = document.querySelectorAll(
      `[data-id="ProductButtons-${currentSectionId}"]`
    );
    if (sourceButtonsWrapper) {
      destButtonsWrappers.forEach((buttonsWrapper) => {
        const sourceHasQuantityPricing =
          sourceButtonsWrapper.dataset.hasQuantityPricing === "true";
        const destHadQuantityPricing =
          buttonsWrapper.dataset.hasQuantityPricing === "true";

        if (sourceHasQuantityPricing || destHadQuantityPricing) {
          if (sourceHasQuantityPricing) {
            buttonsWrapper.dataset.hasQuantityPricing = "true";
          } else {
            buttonsWrapper.removeAttribute("data-has-quantity-pricing");
          }

          const sourceB2bEl = sourceButtonsWrapper.querySelector(
            ".product-b2b-elements"
          );
          const destB2bEl = buttonsWrapper.querySelector(
            ".product-b2b-elements"
          );
          if (sourceB2bEl && destB2bEl) {
            destB2bEl.innerHTML = sourceB2bEl.innerHTML;
          } else if (sourceB2bEl && !destB2bEl) {
            buttonsWrapper.insertAdjacentHTML("afterbegin", sourceB2bEl.outerHTML);
          } else if (!sourceB2bEl && destB2bEl) {
            destB2bEl.remove();
          }

          const sourceQuantityWrapper = sourceButtonsWrapper.querySelector(
            ".product-form__quantity"
          );
          const destQuantityWrapper = buttonsWrapper.querySelector(
            ".product-form__quantity"
          );
          if (sourceQuantityWrapper && destQuantityWrapper) {
            const previousQuantityInput =
              destQuantityWrapper.querySelector(".quantity__input");
            const previousValue = parseInt(previousQuantityInput?.value, 10);

            let quantityWrapperHtml = sourceQuantityWrapper.innerHTML;
            if (sourceSectionId !== currentSectionId) {
              quantityWrapperHtml = quantityWrapperHtml.replaceAll(
                sourceSectionId,
                currentSectionId
              );
            }

            destQuantityWrapper.innerHTML = quantityWrapperHtml;

            const updatedQuantityInput =
              destQuantityWrapper.querySelector(".quantity__input");

            if (updatedQuantityInput) {
              const min = parseInt(updatedQuantityInput.min, 10);
              const max =
                updatedQuantityInput.max !== ""
                  ? parseInt(updatedQuantityInput.max, 10)
                  : null;
              const step = parseInt(updatedQuantityInput.step, 10);
              const fallback = parseInt(updatedQuantityInput.value, 10);

              const validQuantity = this.normalizeQuantityValue({
                desiredQuantity: previousValue,
                min,
                max,
                step,
                fallback,
              });

              updatedQuantityInput.value = String(validQuantity);
              updatedQuantityInput.setAttribute("value", String(validQuantity));
              updatedQuantityInput.setCustomValidity("");
              updatedQuantityInput.dispatchEvent(
                new Event("input", { bubbles: true })
              );
            }
          }
        }
      });
    }

    // product media
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.isCombinedListingsNeedUpdate
    ) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = document.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );
      if (mediaSource && mediaDestination) {
        // sync outer container classes (e.g. product__media--no-media) for combined listings
        if (this.isCombinedListingsNeedUpdate) {
          const parentQuickViewCheck =
            this._cachedQuickViewModal || this.closest("quick-view-modal");
          if (parentQuickViewCheck) {
            // QV strips layout classes via clearMediaClasses(); only sync --no-media
            const hasNoMedia = mediaSource.classList.contains(
              "product__media--no-media"
            );
            mediaDestination.classList.toggle(
              "product__media--no-media",
              hasNoMedia
            );
          } else {
            mediaDestination.className = mediaSource.className;
          }
        }
        // Destroy existing Swiper instances before replacing innerHTML so
        // the old instances don't hold stale DOM references.
        const oldMainSlider = mediaDestination.querySelector(".js-media-list");
        const oldSubSlider =
          mediaDestination.querySelector(".js-media-sublist");
        if (oldMainSlider?.swiper) oldMainSlider.swiper.destroy(true, true);
        if (oldSubSlider?.swiper) oldSubSlider.swiper.destroy(true, true);

        mediaDestination.innerHTML = mediaSource.innerHTML;

        const parentQuickView =
          this._cachedQuickViewModal || this.closest("quick-view-modal");
        const parentFeaturedProduct =
          this._cachedFeaturedProductSection ||
          this.closest(".featured-product-section");
        if (parentQuickView) {
          if (typeof parentQuickView.removeDOMElements === "function") {
            parentQuickView.removeDOMElements(mediaDestination);
          }
          if (typeof parentQuickView.initSlider === "function") {
            parentQuickView.initSlider();
          }
        } else if (parentFeaturedProduct) {
          // Featured product uses the same global Swiper init functions.
          subSliderInit(true);
          sliderInit(true);
        } else {
          // combined listings: replace zoom modal before re-init so zoom shows new product images
          if (this.isCombinedListingsNeedUpdate) {
            const zoomModalSrc = html.getElementById(
              `ProductModal-${sourceSectionId}`
            );
            const zoomModalDst = document.getElementById(
              `ProductModal-${currentSectionId}`
            );
            if (zoomModalSrc && zoomModalDst) {
              const existingSlider =
                zoomModalDst.querySelector(".js-popup-slider");
              if (existingSlider?.swiper) {
                existingSlider.swiper.destroy(true, true);
              }
              zoomModalDst.innerHTML = zoomModalSrc.innerHTML;

              // ModalDialog constructor attaches close-button listeners at
              // construction time. Because zoomModalDst stays in DOM (only its
              // innerHTML changes), the constructor never re-runs for the new
              // close button elements — re-attach them manually.
              // The close button ID prefix is "ModalClose-" (see main-product.liquid).
              zoomModalDst
                .querySelectorAll('[id^="ModalClose-"]')
                .forEach((el) =>
                  el.addEventListener("click", () => zoomModalDst.hide(false))
                );
            }
          }

          // Re-initialize Swiper on the freshly injected gallery elements.
          // subSliderInit must run before sliderInit so the thumb swiper
          // instance exists when the main slider references it.
          subSliderInit(true);
          sliderInit(true);
        }
      }
    }

    if (this.isCombinedListingsNeedUpdate) {
      const newVariantData = html.querySelector(
        "[data-selected-variant]"
      )?.innerHTML;

      const selectedVariant = newVariantData
        ? JSON.parse(newVariantData)
        : null;

      // Derive product title: prefer the heading element from the fetched HTML
      // (always accurate) and fall back to stripping the variant suffix from
      // variant.name. Guard against undefined so we never render "undefined".
      const fetchedTitle = html
        .querySelector(".product__title")
        ?.textContent?.trim();
      const derivedTitle =
        selectedVariant?.name && selectedVariant?.title
          ? selectedVariant.name
              .replace(`- ${selectedVariant.title}`, "")
              .trim()
          : null;
      const productTitle = fetchedTitle || derivedTitle;

      // Scope DOM updates to the current section container when possible so
      // that a featured-product section never touches main-page elements.
      const sectionContainer =
        document.getElementById(`shopify-section-${currentSectionId}`) ||
        document;

      // product title — scoped to the section so featured product doesn't
      // clobber a main-page title or vice-versa.
      if (productTitle) {
        sectionContainer
          .querySelectorAll(".product__title")
          .forEach((titleElem) => {
            titleElem.innerText = productTitle;
          });
      }

      // breadcrumb — only relevant on the main product page (not featured product)
      if (productTitle && sectionContainer === document) {
        const breadcrumbDestination =
          document.querySelector(".breadcrumb span");
        if (breadcrumbDestination) {
          breadcrumbDestination.innerText = productTitle;
        }
      }

      // The selectors below target main-product-page DOM structure
      // (.product .product__outer / .product .product__info-wrapper).
      // Skip them when inside a featured product section to avoid
      // false matches or missed updates.
      const isInFeaturedProduct = Boolean(
        this._cachedFeaturedProductSection ||
          this.closest(".featured-product-section")
      );

      if (!isInFeaturedProduct) {
        // text
        const textDestination = document.querySelector(
          ".product .product__info-wrapper .product__text"
        );
        if (textDestination) {
          const textSource = html.querySelector(
            ".product .product__info-wrapper .product__text"
          );
          if (textSource) textDestination.innerHTML = textSource.innerHTML;
        }

        // about
        const aboutDestination = document.querySelector(
          ".product .product__outer .about"
        );
        if (aboutDestination) {
          const aboutSource = html.querySelector(
            ".product .product__outer .about"
          );
          if (aboutSource) aboutDestination.innerHTML = aboutSource.innerHTML;
        }

        // product buttons
        const buttonsDestination = document.querySelectorAll(
          ".product .product__outer .product-form .form"
        );
        if (buttonsDestination.length) {
          const buttonsSource = html.querySelector(
            ".product .product__outer .product-form .form"
          );
          if (buttonsSource) {
            buttonsDestination.forEach((el) => {
              el.innerHTML = buttonsSource.innerHTML;
            });
          }
        }
      }

      // variants — update both main picker and floated picker so that after
      // a combined listing switch either picker can correctly resolve the new
      // product's options regardless of which one triggered the switch.
      // Handles both variant-radios (button/swatch) and variant-selects (dropdown).
      const realSectionId = liveSection; // "floated-" already stripped
      const variantsRadiosSource = html.querySelector("variant-radios");
      const variantsSelectsSource = html.querySelector("variant-selects");

      if (variantsRadiosSource) {
        // update main radios picker
        const mainVariantsDest = document.getElementById(
          `variant-radios-${realSectionId}-${this.dataset.block}`
        );
        if (mainVariantsDest) {
          mainVariantsDest.innerHTML = variantsRadiosSource.innerHTML;
        }
        // update floated radios picker
        const floatedVariantsDest = document.querySelector(
          ".product .product__info-wrapper .floated-form variant-radios"
        );
        if (floatedVariantsDest) {
          floatedVariantsDest.innerHTML =
            variantsRadiosSource.innerHTML.replaceAll(
              realSectionId,
              `floated-${realSectionId}`
            );
        }
      }

      if (variantsSelectsSource) {
        // update main selects picker
        const mainSelectsDest = document.getElementById(
          `variant-selects-${realSectionId}`
        );
        if (mainSelectsDest) {
          mainSelectsDest.innerHTML = variantsSelectsSource.innerHTML;
        }
        // update floated selects picker
        const floatedSelectsDest = document.querySelector(
          ".product .product__info-wrapper .floated-form variant-selects"
        );
        if (floatedSelectsDest) {
          floatedSelectsDest.innerHTML =
            variantsSelectsSource.innerHTML.replaceAll(
              realSectionId,
              `floated-${realSectionId}`
            );
        }
      }

      // Refresh cached variant data on ALL pickers so subsequent clicks use
      // the new product's variants instead of the previous product's.
      const productWrapper = document.querySelector(
        ".product .product__info-wrapper"
      );
      if (productWrapper) {
        productWrapper
          .querySelectorAll("variant-radios, variant-selects")
          .forEach((vr) => {
            vr.variantData = null;
          });
      } else {
        this.variantData = null;
      }

      // Keep data-url in sync with the active combined product so that future
      // variant requests go to the correct product URL.
      // Update ALL pickers so whichever one the user interacts with next will
      // fetch from the correct (new) combined listing product.
      if (this.currentCombinedProductURL) {
        if (productWrapper) {
          productWrapper
            .querySelectorAll("variant-radios, variant-selects")
            .forEach((vr) => {
              vr.dataset.url = this.currentCombinedProductURL;
              vr.currentCombinedProductURL = this.currentCombinedProductURL;
            });
        } else {
          this.dataset.url = this.currentCombinedProductURL;
        }
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable && !this.is_preorder) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.removeAttribute("aria-disabled");
      addButtonText.textContent = this.is_preorder
        ? this.is_group_buy
          ? "Join Group Buy"
          : "Pre-order"
        : window.variantStrings.addToCart;
      addButtonText.classList.remove("hidden");
      const soldOutMessage = addButton.querySelector(".sold-out-message");
      if (soldOutMessage) soldOutMessage.classList.add("hidden");
      // clear any previous form error message
      const errorWrapper = productForm.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (errorWrapper) errorWrapper.setAttribute("hidden", "");
    }

    if (!modifyClass) return;
  }

  resetErrorMessage() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button?.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    //if (price) price.classList.add("visibility-hidden");
    //if (inventory) inventory.classList.add("visibility-hidden");
    //if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  syncVariantRadios(source, target) {
    const sourceFieldsets = source.querySelectorAll("fieldset");
    const targetFieldsets = target.querySelectorAll("fieldset");
    // target may BE the variant-radios element (it carries data-section directly)
    const targetVariantRadios =
      target.tagName.toLowerCase() === "variant-radios"
        ? target
        : target.querySelector("variant-radios");

    sourceFieldsets.forEach((fieldset, index) => {
      const checked = fieldset.querySelector("input:checked");
      if (!checked) return;

      const targetInput = targetFieldsets[index]?.querySelector(
        `input[value="${checked.value}"]`
      );

      if (targetInput && !targetInput.checked) {
        targetInput.checked = true;
        // Mark the target variant-radios as being synced so it skips
        // the full re-render and avoids a duplicate network request.
        if (targetVariantRadios) targetVariantRadios._syncingFromPeer = true;
        targetInput.dispatchEvent(new Event("change", { bubbles: true }));
        if (targetVariantRadios) targetVariantRadios._syncingFromPeer = false;
      }
    });
  }

  onVariantChange(event) {
    if (this._syncingFromPeer) {
      // Only update the visual state (options, button, statuses) without
      // firing a network request — the initiating form handles that.
      if (!this.contains(event.target)) return;
      this._skipSync = true;
      this.updateOptions();
      this._skipSync = false;
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updateVariantStatuses();
      if (this.currentVariant) {
        this.updateVariantInput();
        this.updateMedia();
      }
      return;
    }
    super.onVariantChange(event);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      )?.value;
    });

    // Skip syncing when we're already being driven by a peer sync
    if (this._skipSync) return;

    // SYNC OTHER SECTION
    let floatedSection;
    const currentSection = this.closest("[data-section]");
    if (!currentSection) return;

    const wrapper = this.closest(".product__info-wrapper");

    if (!wrapper) return;

    const variants = wrapper.querySelectorAll("variant-radios");

    variants.forEach((variantRadio) => {
      if (variantRadio === this) return;
      floatedSection = variantRadio.closest("[data-section]");
    });

    if (!floatedSection) return;

    this.syncVariantRadios(currentSection, floatedSection);
  }
}

customElements.define("variant-radios", VariantRadios);

// dispatch cart:refresh

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// dispatch cart:refresh
